<template>
	<div class="bs-right">
		<div class="gov-task-section">
			<BSBlock class="bsblock" title="承接政府重点工作" fangxiang="right" danwei=""></BSBlock>
			<div class="bsbox-w gov-task-row">
				<div class="gov-task-card gov-task-card--pochan">
					<ZCpochanqiyeduifu />
				</div>
				<div class="gov-task-card gov-task-card--bank">
					<ZCzaozhuangbankguquanzhuanrang />
				</div>
				<div class="gov-task-card gov-task-card--tongxing">
					<ZCtongxingchangtoushouyi />
				</div>
			</div>
		</div>
		<div style="height:31%">
			<BSBlock class="bsblock" title="不良资产清收概况" fangxiang="right" danwei="个数"></BSBlock>
			<div class="bsbox-w">
				<div class="bsbox">
					<ZCbuliangzichanbaoxingzhizhanbi @chart-click="handleChartClick" />
				</div>
				<div class="bsbox">
					<ZCbuliangzichanbaoxingzhizhanbi2 @chart-click="handleChartClick"/>
				</div>
			</div>
		</div>
		<div style="height:38%">
			<BSBlock class="bsblock" title="资产占股比例" fangxiang="right" danwei="%"></BSBlock>
			<div class="bsbox-w bsbox-tree">
				<ZCEquityOrgTree />
			</div>
		</div>
	</div>
</template>

<script>
	import BSBlock from "../../components/TitleBlock.vue";
	import ZCpochanqiyeduifu from "../../views/index/charts/ZCpochanqiyeduifu.vue"; //破产企业兑付
	import ZCzaozhuangbankguquanzhuanrang from "../../views/index/charts/ZCzaozhuangbankguquanzhuanrang.vue"; //枣庄银行股权划转
	import ZCtongxingchangtoushouyi from "../../views/index/charts/ZCtongxingchangtoushouyi.vue"; //同兴公司长投收益
	import ZCbuliangzichanbaoxingzhizhanbi from "../../views/index/charts/ZCbuliangzichanbaoxingzhizhanbi.vue"; //不良资产包性质占比
	import ZCbuliangzichanbaoxingzhizhanbi2 from "../../views/index/charts/ZCbuliangzichanbaoxingzhizhanbi2.vue"; //不良资产包性质占比2
	import ZCEquityOrgTree from "../../views/index/charts/ZCEquityOrgTree.vue"; //股权组织架构树


	export default {
		components: {
			BSBlock,
			ZCpochanqiyeduifu,
			ZCzaozhuangbankguquanzhuanrang,
			ZCtongxingchangtoushouyi,
			ZCbuliangzichanbaoxingzhizhanbi,
			ZCbuliangzichanbaoxingzhizhanbi2,
			ZCEquityOrgTree,
		},

		methods: {
			handleChartClick(data) {
				// 将事件传递给父组件（index.vue）
				this.$emit('chart-click', data);
			},
			handleDataClick(data) {
				// 将事件传递给父组件（index.vue）
				this.$emit('data-click', data);
			}
		},
	};
</script>

<style lang="scss" scoped>
	.bs-right {
		padding: 10px 0px 20px;
		width: calc(33% - 20px);
		height: calc(100% - 30px);
		margin-left: 20px;
		flex-shrink: 0;
		flex-grow: 0;
		position: relative;
		z-index: 1;
	}

	// .bsblock {
	// 	background: linear-gradient(to right, rgb(255 255 255 / 20%) 20%, rgb(255 255 255 / 0%) 100%),
	// }
	.bsbox-w {
		display: flex;
		height: calc(100% - 3vh);
	}

	.bsbox-tree {
		width: 100%;
	}

	.bsbox {
		width: 50%;
		height: 100%;
		display: flex;
		align-items: center;
		overflow: visible;
	}

	/* 承接政府重点工作：三指标分区 */
	.gov-task-section {
		height: 31%;
		overflow: visible;
		position: relative;
		z-index: 5;
	}

	.gov-task-row {
		gap: 5px;
		padding: 5px 6px 8px;
		box-sizing: border-box;
		align-items: stretch;
		overflow: visible;
	}

	.gov-task-card {
		height: 100%;
		min-width: 0;
		display: flex;
		flex-direction: column;
		padding: 6px 4px 8px;
		box-sizing: border-box;
		background: transparent;
		position: relative;
		overflow: visible;
	}

	.gov-task-card--pochan {
		flex: 0 0 24%;
		border-right: 1px solid rgba(0, 180, 255, 0.25);
	}

	.gov-task-card--bank {
		flex: 1;
		border-right: 1px solid rgba(0, 180, 255, 0.25);
	}

	.gov-task-card--tongxing {
		flex: 1;
	}

	.gov-task-card > * {
		width: 100%;
		height: 100%;
		min-height: 0;
		flex: 1;
		position: relative;
	}

	/* 图表本体保持低层级；弹窗使用 fixed + dashboard-chart-popup，不受此处层叠限制 */
	.gov-task-card > .pochan-wrap,
	.gov-task-card > .guquan-wrap,
	.gov-task-card > .tongxing-wrap {
		z-index: 0;
	}

	.chart-sub-title {
		font-size: 11px;
		color: #fcf883;
		text-align: center;
		padding: 2px 0 2px;
		letter-spacing: 1px;
		flex-shrink: 0;
	}
</style>